export const LoadJanrainScript = function() {
  // --- BEGIN WIDGET INJECTION CODE -----------------------------------------
  /********* WARNING: *******************************************************\
    |      DO NOT EDIT THIS SECTION                                            |
    | This code injects the Capture Widget. Modifying this code can cause the  |
    | Widget to load incorrectly or not at all.                                |
    \**************************************************************************/

  janrain.ready = true;

  const injector = document.createElement("script");
  injector.type = "text/javascript";
  injector.id = "janrainAuthWidget";
  injector.src = document.location.protocol === "https:" ? janrain.settings.httpsLoadUrl : janrain.settings.httpLoadUrl;
  const firstScript = document.getElementsByTagName("script")[0];
  firstScript.parentNode.insertBefore(injector, firstScript);

  // --- END WIDGET INJECTION CODE -------------------------------------------
};
